module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData1
    }
  })], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search",
      "on-icon-click": _vm.srchDevice
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('tagc', {
          attrs: {
            "tagobj": {
              type: 'terSt',
              vl: scope.row.terminalStatus
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName'),
      "prop": "appName"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appName : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_introl'),
      "prop": "appDesc"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }]
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "border": "0",
      "height": "100%",
      "background": "none",
      "position": "absolute"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 1000
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.prdes),
      callback: function($$v) {
        _vm.prdes = $$v
      },
      expression: "prdes"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 9999
      }
    },
    model: {
      value: (_vm.form.appDesc),
      callback: function($$v) {
        _vm.$set(_vm.form, "appDesc", $$v)
      },
      expression: "form.appDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "distributorId"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.distributorName : ''))]), _vm._v(" "), _c('MechanismSelector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "appTypeValue"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appCategoryName : ''))]), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon() && _vm.form.distributorId),
      expression: "isShowCommon() && form.distributorId"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_type')
    },
    model: {
      value: (_vm.form.appTypeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "appTypeValue", $$v)
      },
      expression: "form.appTypeValue"
    }
  }, _vm._l((_vm.appTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUpdateDesc),
      expression: "isShowUpdateDesc"
    }],
    attrs: {
      "label": _vm.$t('app_udState'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    staticStyle: {
      "width": "100%",
      "float": "left"
    },
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 99999
      }
    },
    model: {
      value: (_vm.updateDescContent),
      callback: function($$v) {
        _vm.updateDescContent = $$v
      },
      expression: "updateDescContent"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_selectApp'),
      "prop": "appUrl"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }]
  }, [_vm._v(_vm._s(_vm.config ? _vm.makeAppPath() : ''))]), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon() && _vm.form.distributorId),
      expression: "isShowCommon() && form.distributorId"
    }],
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index == 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-5px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：" + _vm._s(_vm.form.version))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：" + _vm._s(_vm.form.verTag))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-10px",
      "color": "#8c939d"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：" + _vm._s(_vm.form.packageName))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')) + "apk/hap")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index == 0),
      expression: "ulinfo.index == 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingSm),
      expression: "loadingSm"
    }],
    attrs: {
      "label": _vm.$t('app_icon'),
      "prop": "smImageUrlValue"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "width": "72px",
      "height": "72px"
    },
    attrs: {
      "src": _vm.sIcon
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "on-success": _vm.handleSmAvatarSuccess,
      "before-upload": _vm.beforeSmAvatarUpload
    }
  }, [(_vm.smImageUrl) ? _c('img', {
    staticClass: "sm-avatar",
    attrs: {
      "src": _vm.smImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus sm-avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_iconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBig),
      expression: "loadingBig"
    }],
    attrs: {
      "label": _vm.$t('app_larIcon'),
      "prop": "bgImageUrlValue"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg",
    staticStyle: {
      "width": "120px",
      "height": "120px"
    },
    attrs: {
      "src": _vm.bIcon
    },
    on: {
      "click": _vm.showBigPic
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "avatar-uploader aeMg",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "on-success": _vm.handleBgAvatarSuccess,
      "before-upload": _vm.beforeBgAvatarUpload
    }
  }, [(_vm.bgImageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.bgImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v("\n\t\t\t\t\t  "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "contentColor"
  }, [_vm._v(_vm._s(_vm.$t('app_larIconState')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type !== 3 || _vm.path),
      expression: "config.type!==3 || path"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading1),
      expression: "loading1"
    }],
    attrs: {
      "label": _vm.$t('app_screenShot'),
      "prop": "caps"
    }
  }, [_vm._l((_vm.captures), function(path, index) {
    return _c('div', {
      staticStyle: {
        "float": "left",
        "margin-left": "10px"
      },
      attrs: {
        "id": "aeCpDiv"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isShowCommon(1)),
        expression: "isShowCommon(1)"
      }],
      staticClass: "cImg",
      attrs: {
        "src": _vm.imgFullUrl(path)
      },
      on: {
        "click": function($event) {
          _vm.showScreenShot(path, index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "text-align": "left",
      "padding": "0 0 0 15px"
    },
    attrs: {
      "id": "aeCap"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp0
    }
  }, [_c('div', {
    staticStyle: {
      "display": "-webkit-flex",
      "justify-content": "center",
      "align-items": "center",
      "clear": "both"
    }
  }, [(_vm.cp0) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp0
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture0()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp1
    }
  }, [(_vm.cp1) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp1
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture1()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp2
    }
  }, [(_vm.cp2) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture2()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp3
    }
  }, [(_vm.cp3) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp3
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture3()
      }
    }
  }), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "capture",
    attrs: {
      "action": _vm.imgUploadUrl,
      "show-file-list": false,
      "name": "file",
      "before-upload": _vm.tipBf,
      "on-success": _vm.handleAvatarSuccessCp4
    }
  }, [(_vm.cp4) ? _c('img', {
    staticClass: "avatarF",
    attrs: {
      "src": _vm.cp4
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "el-icon-delete",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.deleteCapture4()
      }
    }
  })], 1)], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyPre
    }
  }, [_vm._v(_vm._s(_vm.$t('app_submit')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2 && _vm.config.isHistory),
      expression: "config.type === 2 && config.isHistory"
    }],
    staticStyle: {
      "border-top": "1px solid #8492A6",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "float": "right",
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin": "20px 0 20px 0"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appName",
      "label": _vm.$t('app_appName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "appCategoryName",
      "width": "",
      "label": _vm.$t('app_type')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "90",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.appStatus !== '1' && scope.row.appStatus !== '2'),
            expression: "scope.row.appStatus !== '1' && scope.row.appStatus !== '2'"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteAppHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }]
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33e132cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/appedit.vue
// module id = 1007
// module chunks = 0